import { AppBar, Toolbar, IconButton, Stack, Button, Link, Menu, useTheme, useMediaQuery, MenuList, Drawer, Box } from "@mui/material";
import { ReactComponent as PathwayLogo } from "../../assets/images/logos/pathway-logo.svg";
import { Logo } from "../Logo";
import { useState } from "react";
import MenuIcon from '@mui/icons-material/Menu';
export const Navbar = () => {
    const [value, setValue] = useState();
    const [mobileOpen, setMobileOpen] = useState(false);
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));
    const handleDrawerToggle = () => {
        setMobileOpen(!mobileOpen);
    };
    return (
        <AppBar position='static' sx={{backgroundColor: '#ffffff'}}>
            <Toolbar sx={{justifyContent:"space-between"}}  variant="dense">
                
                <IconButton size="large" edge='start' aria-label='logo' sx={{ "&:hover": { backgroundColor: "transparent" } }}>
                    <Logo padding={1} size={isMobile ? '150px' : '300px'}/>
                </IconButton>
                <Stack direction="row" spacing={4} sx={{marginRight: '30px', display: { xs: 'none', md: 'block' },}} >
                    <Link sx={{color: '#004f68'}} href="https://yourpathway.com/rent-to-own-homes">Browse Homes</Link>
                    <Link sx={{color: '#004f68'}} href="https://yourpathway.com/how-it-works">How it Works</Link>
                    <Link sx={{color: '#004f68'}} href="https://yourpathway.com/about-us">About Us</Link>
                </Stack>

                {isMobile && (
                    <>
                    <IconButton 
                        edge="start"
                        color="inherit"
                        aria-label="open drawer"
                        onClick={() => handleDrawerToggle()}
                        sx={{ mr: 2, display: { xs: 'block', sm: 'none',}, }}>   
                        <MenuIcon sx={{ color: '#164C63' }}/>
                    </IconButton>
                    <Drawer
                        anchor='right'
                        open={mobileOpen}
                        onClose={handleDrawerToggle}
                        ModalProps={{
                            keepMounted: true, // Better open performance on mobile.
                          }}
                        >
                        <Stack direction="column" justifyContent="center" spacing={2} sx={{width: '300px', mt: '30px', p: '30px', textAlign: 'center'}} >
                            <Logo padding={1} size={'200px'}/>
                            <Link sx={{color: '#004f68'}} href="https://yourpathway.com/rent-to-own-homes">Browse Homes</Link>
                            <Link sx={{color: '#004f68'}} href="https://yourpathway.com/how-it-works">How it Works</Link>
                            <Link sx={{color: '#004f68'}} href="https://yourpathway.com/about-us">About Us</Link>
                        </Stack>
                    </Drawer>
                    </>
                )}
                
                <Menu id="mobile-nav">

                </Menu>
            </Toolbar>
        </AppBar>
    )
}